import angular from 'angular'
import { ScanHistoryComponent } from './scan-history.component'

const ProjectWebscannerScanHistoryModule = angular
  .module('cdbl.project-webscanner-scan-history', [])
  .component('cdblProjectWebscannerScanHistoryModal', ScanHistoryComponent)
  .name

export default ProjectWebscannerScanHistoryModule
